// absolute imports
import { createFileRoute, Outlet } from '@tanstack/react-router';

// relative imports
import BrowserCheck from '../components/shared/browser-detection/BrowserCheck';
// import ModalRenderer from '../components/shared/modals/ModalRenderer';
import IdleTimer from '../components/shared/authentication/IdleTimer';
import { GoogleTagManager } from '../components/shared/google-tag-manager/GTMContainer';
// import GQLErrorBoundary from '../components/error-handling/GQLErrorBoundary';
import FullScreenLayout from '../components/shared/layouts/FullScreenLayout';

function PublicRouteWrapper() {
  return (
    <>
      {!window.Cypress && <GoogleTagManager />}
      <IdleTimer />
      <BrowserCheck />
      <FullScreenLayout>
        <Outlet />
      </FullScreenLayout>
    </>
  );
}

export const Route = createFileRoute('/_public')({
  component: PublicRouteWrapper,
});
